<script>
import StrOccupationDataTableSelect from "@/components/StrOccupationDataTableSelect.vue";
import useSharedData from "@/use/SharedData.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {ref} from "vue";
import axios from "axios";

export default {
    components: {StrOccupationDataTableSelect},
    setup() {
        const {loading, dialog,} = useSharedData();
        const {getBack} = useSharedMethod();

        const filter = ref({
            paySectionId: [],
        });
        const selectedOccupation = ref([]);
        const replaceOption = ref("worker");
        const updating = ref(true);

        function set() {
            loading.value = true;
            const ids = selectedOccupation.value.map(element => element.id);
            const body = {ids: ids};
            filter.value.updating = updating.value;
            filter.value.replaceOption = replaceOption.value;
            axios.put(`/workers/setPaySections`, body, {
                params: filter.value,
            }).then(() => {
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        function updateSelectedOccupation(items) {
            selectedOccupation.value = items;
        }

        function updateFilter(item) {
            filter.value = item;
        }

        return {
            loading,
            dialog,
            filter,
            replaceOption,
            updating,
            selectedOccupation,
            set,
            updateSelectedOccupation,
            updateFilter,
            getBack,
        }
    },
}
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        scrollable
        max-width="1400"
    >
        <v-card>
            <w-toolbar color="orange" :title="$t('occupation.set_pay_section')"/>
            <v-divider/>
            <v-card-text>
                <v-container fluid>
                    <v-row dense>
                        <v-col cols="4">
                            <v-row>
                                <v-col cols="12">
                                    <v-radio-group v-model="updating" row hide-details>
                                        <v-radio
                                            :value="true"
                                            :label="$t('occupation.update_worker_pay_sections')"
                                            color="teal"
                                        ></v-radio>
                                        <v-radio
                                            :value="false"
                                            :label="$t('occupation.reset_worker_pay_sections')"
                                            color="red"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="12" v-if="updating">
                                    <v-radio-group v-model="replaceOption" hide-details>
                                        <v-radio :value="'worker'" color="teal">
                                            <template v-slot:label>
                                                <div>
                                                    {{ $t("occupation.save_worker_pay_section") }}
                                                    <strong class="success--text">
                                                        ({{ $t("common.recommended") }})
                                                    </strong>
                                                </div>
                                            </template>
                                        </v-radio>
                                        <v-radio
                                            :value="'occupation'"
                                            :label="$t('occupation.save_occupation_pay_section')"
                                            color="orange"
                                        ></v-radio>
                                        <v-radio
                                            :value="'double'"
                                            :label="$t('occupation.double')"
                                            color="purple"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>
                                <v-col cols="9" v-else>
                                    <v-alert dense text type="error">
                                        {{ $t('occupation.import_alert') }}
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-divider class="mt-2"/>
                            <v-alert
                                class="mt-2"
                                text
                                dense
                                color="teal"
                                icon="mdi-clock-fast"
                                border="left"
                                v-if="selectedOccupation.length === 0"
                            >
                                {{ $t("common.occupation_select_description") }}
                            </v-alert>
                        </v-col>
                        <v-col cols="8">
                            <str-occupation-data-table-select
                                :id="$route.params.id"
                                @updateSelectedOccupation="updateSelectedOccupation"
                                @updateFilter="updateFilter"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-update
                    show
                    :loading="loading"
                    @press="set"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>